import React from 'react';
import {connect} from 'react-redux'

import ChatListRecentSegment from './chat_list_recent_segment'
import ChatListAdminSegment from './chat_list_admin_segment'
import ChatListAuthorSegment from './chat_list_author_segment'
import ChatListExpertSegment from './chat_list_expert_segment'
import ChatListUserSegment from './chat_list_user_segment'
import ChatListGroupChatSegment from './chat_list_group_chat_segment'

class ChatList extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};
  }

  getSortedSegmentKeys (segments) {
    return Object.keys(segments).sort((a, b) => segments[a].order - segments[b].order )
  }

  render () {
    const segments = this.props.segments
    const segmentUIs = {
      recents: <ChatListRecentSegment key='recents'/>,
      groups: <ChatListGroupChatSegment key='groups'/>,
      admins: <ChatListAdminSegment key='admins'/>,
      writers: <ChatListAuthorSegment key='writers'/>,
      experts: <ChatListExpertSegment key='experts'/>,
      users: <ChatListUserSegment key='users'/>
    }

    const sortedSegmentKeys = this.getSortedSegmentKeys(segments)

    return (
      <div className={'chat-list ' + this.props.className} style={{backgroundColor: this.props.background}}>
        <div style={{width: '100%', height: '100%', overflowX: 'hidden', overflowY: 'auto'}}>
          {sortedSegmentKeys.map(key => segmentUIs[key])}
        </div>
      </div>
    )
  }
}

ChatList.defaultProps = {}

const mapStateToProps = (state) => {
  return {
    background: state.getIn(['chatSettings', 'colors', 'chatList', 'background']),
    segments: state.getIn(['chatSettings', 'segments']).toJS()
  }
}

const ChatListContainer = connect(
  mapStateToProps
)(ChatList)

export default ChatListContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list.js
 **/